<p-table #reqlist
         [columns]="cols"
         [value]="requisitions"
         [filters]="filters"
         [lazy]="true"
         (onLazyLoad)="loadReportLazy($event)"
         [paginator]="true"
         [rows]="5"
         [totalRecords]="totalRecords"
         [loading]="loading">
  <ng-template pTemplate="caption">
    <div style="height: 30px; width: 100%">
      <span class="float-left">Billing Report</span>
      <div class="float-right ml-4">
        <a (click)="reqlist.filter('', 'Accession', 'equals')" class="text-white" style="font-size: 24px" href="javascript:void(0)" title="Refresh"><i class="fa-refresh fa"></i> </a>
      </div>
      <div class="float-right ml-4">
        <a (click)="clear(reqlist)" class="text-white" style="font-size: 24px" href="javascript:void(0)" title="Clear sort and filters"><i class="fa-undo fa"></i> </a>
      </div>
      <div class="float-right ml-4">
        <a (click)="downloadReport($event, reqlist)" class="text-white" style="font-size: 24px" href="javascript:void(0)" title="Create Excel Report"><i class="fa-file-excel fa"></i> </a>
      </div>
      <div class="float-right ml-4">
        <input pInputText type="text" (keyup.enter)="applyGlobalFilter($event.target.value, reqlist)" placeholder="Search keyword" />
      </div>
      <div class="float-right text-white font-weight-bold">
        {{totalRecords | number}} rows
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns >
    <tr>
      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [style.width]="col.width">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    </tr>
    <tr>
      <th *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.filter">
          <span *ngSwitchCase="'currency'">
            <p-columnFilter type="numeric"
                            [field]="col.field"
                            display="menu"
                            currency="USD"
                            [showMatchMode]="true"
                            [showOperator]="false"
                            [showAddButton]="false">
              <ng-template pTemplate="filter" let-value let-filterCallback="filterCallback">
                <input type="number"
                       [ngModel]="value"
                       (change)="filterCallback($event.target.value)"
                       class="p-inputtext"
                       placeholder="enter amount">
              </ng-template>
            </p-columnFilter>
          </span>
          <span *ngSwitchCase="'list'">
            <div class="flex">
              <p-columnFilter [field]="col.field"
                              matchMode="in"
                              display="menu"
                              (click)="$event.stopPropagation()"
                              [showMatchModes]="false"
                              [showOperator]="false"
                              [showAddButton]="false">
                <ng-template pTemplate="filter" let-label let-filter="filterCallback">
                  <p-multiSelect [(ngModel)]="billingSubStatuses"
                                 optionLabel="label"
                                 optionValue="value"
                                 [options]="col.filterList"
                                 (onChange)="multiSelectFilter(filter, $event.value)"
                                 placeholder="All Values">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </div>
          </span>
          <span *ngSwitchCase="'date'">
            <p-columnFilter type="date"
                            [field]="col.field"
                            display="menu"
                            (click)="$event.stopPropagation()"
                            [showOperator]="false" />
          </span>
          <span *ngSwitchCase="'boolean'">
            <p-columnFilter type="boolean"
                            [field]="col.field"
                            display="menu"
                            (click)="$event.stopPropagation()"
                             />
          </span>
          <span *ngSwitchDefault>
            <p-columnFilter type="text"
                            [field]="col.field"
                            display="menu"
                            [showOperator]="false"
                            [showAddButton]="false" />
          </span>
        </ng-container>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td *ngFor="let col of columns">
        <ng-container [ngSwitch]="col.type">
          <span *ngSwitchCase="'currency'">
            <div class="text-right">
              {{ rowData[col.field] | currency }}
            </div>
          </span>
          <span *ngSwitchCase="'date'">
            {{ rowData[col.field] | date:'yyyy-MM-dd' }}
          </span>
          <span *ngSwitchCase="'bool'">
            <div class="text-center">
              <i class="pi" [ngClass]="{ 'pi-check text-green-500': rowData[col.field], 'pi-times text-red-500': !rowData[col.field] }"></i>
            </div>
          </span>
          <span *ngSwitchCase="'textO'">
            <div class="truncate-cell" [pTooltip]="rowData[col.field]">
              {{ rowData[col.field] }}
            </div>
          </span>
          <span *ngSwitchDefault>
            {{ rowData[col.field] }}
          </span>
        </ng-container>
      </td>
    </tr>
  </ng-template>
</p-table>
